import api from './api';
import { NetworkAnalysis, StartNetworkAnalysisInput } from '../types';

export async function startNetworkAnalysis(
  input: StartNetworkAnalysisInput
): Promise<NetworkAnalysis> {
  const response = await api.post<NetworkAnalysis>('/network-analyses', input);
  return response.data;
}

export async function getNetworkAnalysesByClient(clientId: string): Promise<NetworkAnalysis[]> {
  const response = await api.get<NetworkAnalysis[]>(`/network-analyses?clientId=${clientId}`);
  return response.data;
}

export async function getNetworkAnalysis(id: string): Promise<NetworkAnalysis> {
  const response = await api.get<NetworkAnalysis>(`/network-analyses/${id}`);
  return response.data;
}
